import * as React from "react";

export const SvgWebsiteContent = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M5.364 4.545h12.363a.773.773 0 0 0 0-1.545H5.364a.773.773 0 0 0 0 1.545ZM17.727 9.182H5.364a.773.773 0 0 0 0 1.545h12.363a.773.773 0 1 0 0-1.545ZM17.727 15.364H5.364a.773.773 0 0 0 0 1.545h12.363a.773.773 0 0 0 0-1.545ZM2.273 3a.78.78 0 0 0-.547.226.78.78 0 0 0-.226.547.78.78 0 0 0 .226.546.78.78 0 0 0 .547.226.78.78 0 0 0 .546-.226.78.78 0 0 0 .226-.546.78.78 0 0 0-.226-.547A.78.78 0 0 0 2.273 3ZM2.273 9.182a.78.78 0 0 0-.547.226.778.778 0 0 0-.226.547.78.78 0 0 0 .226.546.78.78 0 0 0 .547.226.778.778 0 0 0 .546-.226.78.78 0 0 0 .226-.546.778.778 0 0 0-.226-.547.778.778 0 0 0-.546-.226ZM2.273 15.364a.78.78 0 0 0-.547.226.78.78 0 0 0-.226.546.78.78 0 0 0 .226.547.78.78 0 0 0 .547.226.78.78 0 0 0 .546-.226.78.78 0 0 0 .226-.547.78.78 0 0 0-.226-.546.78.78 0 0 0-.546-.226Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
	</svg>
);
